import { render, staticRenderFns } from "./TwoFactorLayout.vue?vue&type=template&id=8963f296"
import script from "./TwoFactorLayout.vue?vue&type=script&lang=js"
export * from "./TwoFactorLayout.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorLayout.vue?vue&type=style&index=0&id=8963f296&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports